// src/common/security/api.js
// Cloud Functions çağrıları (prod + emu fallback)

const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID || "aractakip-e606b";
const REGION = process.env.REACT_APP_FUNCTIONS_REGION || "us-central1";
const PROD_BASE = `https://${REGION}-${PROJECT_ID}.cloudfunctions.net`;
const EMU_BASE  = `http://127.0.0.1:5001/${PROJECT_ID}/${REGION}`;

async function fetchJson(fnName, body) {
  const urlProd = `${PROD_BASE}/${fnName}`;
  const urlEmu  = `${EMU_BASE}/${fnName}`;
  try {
    const r = await fetch(urlProd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {}),
      credentials: "omit",
    });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return await r.json();
  } catch (e) {
    const r2 = await fetch(urlEmu, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {}),
      credentials: "omit",
    });
    if (!r2.ok) throw new Error(`HTTP ${r2.status}`);
    return await r2.json();
  }
}

// ---- Güvenlik ----
export async function securityCheck(payload) {
  return fetchJson("securityCheck", payload);
}
export async function adminListThreats(adminEmail) {
  return fetchJson("adminListThreats", { adminEmail });
}
export async function adminAction(adminEmail, payload) {
  return fetchJson("adminAction", { adminEmail, ...(payload || {}) });
}

// ---- Login oturumları ----
export async function upsertLoginSession({ email, fingerprint, deviceInfo, deviceType }) {
  return fetchJson("upsertLoginSession", { email, fingerprint, deviceInfo, deviceType });
}
export async function endLoginSession({ sessionId }) {
  return fetchJson("endLoginSession", { sessionId });
}

// ---- Beacon (sayfa kapanırken) için salt URL lazım olduğunda:
export const FUNCTIONS_BASES = { PROD_BASE, EMU_BASE };
